import { render, staticRenderFns } from "./SatisList.vue?vue&type=template&id=c8ae6540"
import script from "./SatisList.vue?vue&type=script&lang=ts"
export * from "./SatisList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports